<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color pa-4">
      <div>
        <ValidationObserver ref="observer">
          <v-data-table
            id="wave_details_table"
            :headers="detailsHeaders"
            :items="stockOuts"
            multi-sort
            class="elevation-2 px-4 mt-4"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:top>
              <v-toolbar flat class="transparent-background-color">
                <v-toolbar-title class="ms-n2">
                  <span class="red--text">{{ wave.wave_code }}</span>
                  {{ $t("Wave.StockSortingFields.stock_order_binding") }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="toStockSorting()"
                  >{{ $t("Wave.StockSortingFields.Opt.next") }}</v-btn
                >
              </v-toolbar>
              <v-divider />
            </template>
            <template v-slot:item.container_bar_code="{ item }">
              <ValidationProvider
                v-if="!item.container_bar_code"
                v-slot="{ errors }"
                rules="trequired"
              >
                <SetTimeOutInput
                  v-model="item.container_bar_code_input"
                  class="input-center container_input"
                  :label="$t('Wave.StockSortingFields.container_bar_code')"
                  :show-messages="!errors || errors.length == 0"
                  :error-messages="errors"
                  @input="stockOutsBindingContainers(item, $event)"
                />
              </ValidationProvider>
              <v-text-field
                v-else
                v-model="item.container_bar_code"
                class="input-center"
                single-line
                style="max-width: 230px; margin-left: auto; margin-right: auto"
                :label="$t('Wave.StockSortingFields.container_bar_code')"
                disabled
              ></v-text-field>
            </template>
          </v-data-table>
        </ValidationObserver>
      </div>
    </v-sheet>
  </div>
</template>
<script>
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Waves from "@/api/waves";
import Containers from "@/api/containers";
import snackbar from "@/plugins/snackbar";
import SetTimeOutInput from "@/components/plugins/SetTimeOutInput";

export default {
  components: {
    Breadcrumbs,
    ValidationObserver,
    ValidationProvider,
    SetTimeOutInput,
  },
  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          replace: true,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          replace: true,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.waves"),
          disabled: false,
          href: "/waves",
        },
        {
          text: i18n.t("Nav.stockOrderBinding"),
          disabled: true,
        },
      ];
      return items;
    },

    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("Wave.StockOrderBindingFields.location"),
          sortable: false,
          align: "center",
          value: "location_num",
        },
        {
          text: i18n.t("Wave.StockOrderBindingFields.stock_out_code"),
          sortable: false,
          align: "center",
          value: "stock_order_code",
        },
        {
          text: i18n.t("StockContainers.title"),
          sortable: false,
          align: "center",
          value: "container_bar_code",
        },
      ];

      return headers;
    },
  },

  data: () => ({
    panels: [0],
    wave: [],
    stockOuts: [],
    container_bar_code: "",
    containers: [],
  }),

  mounted() {
    this.getStockOutList();
  },

  methods: {
    //获取波次详情
    getStockOutList() {
      Waves.getSortingInfoList(
        this.$route.params.id,
        this.$route.query.stock_id
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.wave = response.data.waves;
            this.stockOuts = response.data.waves.stock_order_wave_details;
            this.stockOuts.forEach((stock_out,key)=>{
              stock_out.location_num = key+1;
            })
            this.$nextTick(() => {
              //第一个值为空的容器条码input自动获取焦点
              let containerInputs = document.getElementsByClassName(
                "container_input"
              );
              Object.keys(containerInputs).some(function (item) {
                if (
                  !containerInputs[item].querySelector("input").value.length
                ) {
                  containerInputs[item].querySelector("input").focus();
                  return true;
                }
              });
            });
          }
        }.bind(this)
      );
    },
    //出库单绑定容器
    stockOutsBindingContainers(stock_out, container_bar_code_input) {
      //判断要绑定的容器是否已占用
      if (container_bar_code_input) {
        Containers.fetchOne({
          bar_code: container_bar_code_input,
          stock_id: this.$route.query.stock_id,
        }).then(
          function (response) {
            if (response.data.status.isOK()) {
              if (response.data.container.status) {
                //接口判断容器是否已被占用
                snackbar.error(
                  i18n.t("Wave.StockSortingFields.container_is_occupied_hint", [
                    container_bar_code_input,
                  ])
                );
                stock_out.container_bar_code_input = "";
              } else {
                //页面判断容器是否已被占用
                if (this.containers.indexOf(container_bar_code_input) > -1) {
                  snackbar.error(
                    i18n.t(
                      "Wave.StockSortingFields.container_is_occupied_hint",
                      [container_bar_code_input]
                    )
                  );
                  stock_out.container_bar_code_input = "";
                } else {
                  this.containers[stock_out.id] = container_bar_code_input;
                  const container = this.findFormItem(document.activeElement);
                  this.findInput(container) &&
                    this.findInput(container).focus();
                }
              }
            } else {
              stock_out.container_bar_code_input = "";
            }
          }.bind(this)
        );
      }
    },
    findFormItem(el) {
      const parent = el.parentElement;
      if (!parent) return document.body;
      if (parent.tagName == "TR") {
        return parent;
      }
      return this.findFormItem(parent);
    },
    findInput(container) {
      let nextEl = container.nextElementSibling;
      if (!nextEl) {
        //自动提交容器绑定，进入下一步
        this.toStockSorting();
        return;
      }
      let input = nextEl.querySelector("input");
      return input;
    },
    //分拣
    toStockSorting() {
      var submit_data_details = []; //未绑定要提交的数据
      var binding_containers = []; //已绑定
      this.stockOuts.forEach(
        function (stock_out) {
          if (
            !stock_out.container_bar_code &&
            stock_out.container_bar_code_input
          ) {
            submit_data_details.push({
              container_bar_code: stock_out.container_bar_code_input,
              wave_detail_id: stock_out.id,
            });
          } else if (stock_out.container_bar_code) {
            binding_containers.push(stock_out.container_bar_code);
          }
        }.bind(this)
      );
      //若出库单都绑定则跳过验证直接跳转到分拣商品页面
      if (binding_containers.length == this.stockOuts.length) {
        this.$router.replace(
          "/waves/stock-sorting/" +
            this.$route.params.id +
            "?stock_id=" +
            this.$route.query.stock_id
        );
      } else {
        this.$refs.observer.validate().then(
          function (result) {
            if (result) {
              Waves.stockOrderContainerBinding({
                stock_id: this.$route.query.stock_id,
                wave_id: this.$route.params.id,
                stock_order_wave_details: submit_data_details,
              }).then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$router.replace(
                      "/waves/stock-sorting/" +
                        this.$route.params.id +
                        "?stock_id=" +
                        this.$route.query.stock_id
                    );
                  }
                }.bind(this)
              );
            }
          }.bind(this)
        );
      }
    },
  },
};
</script>